import { useEffect } from "react";
import { useAppSelector } from "../redux/hooks";
import { useLocation } from "@tanstack/react-router";

const useGaTracking = () => {
  const user = useAppSelector((state) => state.user);
  const pathname = useLocation({ select: (location) => location.pathname });
  const searchStr = useLocation({ select: (location) => location.searchStr });

  useEffect(() => {
    if (window.ga) {
      if (user) {
        window.ga("set", "dimension13", user.is_staff);
        window.ga("set", "dimension14", user.user_id);
      }
      window.ga("set", "page", pathname + searchStr);
    }
  }, [pathname, searchStr, user]);
};

export default useGaTracking;
